// Action types for API Key management

// Fetch API Keys List
export const FETCH_API_KEYS = {
  REQUEST: 'FETCH_API_KEYS_REQUEST',
  SUCCESS: 'FETCH_API_KEYS_SUCCESS',
  FAILURE: 'FETCH_API_KEYS_FAILURE',
};

// Fetch API Key Detail
export const FETCH_API_KEY_DETAIL = {
  REQUEST: 'FETCH_API_KEY_DETAIL_REQUEST',
  SUCCESS: 'FETCH_API_KEY_DETAIL_SUCCESS',
  FAILURE: 'FETCH_API_KEY_DETAIL_FAILURE',
};

// Create API Key
export const CREATE_API_KEY = {
  REQUEST: 'CREATE_API_KEY_REQUEST',
  SUCCESS: 'CREATE_API_KEY_SUCCESS',
  FAILURE: 'CREATE_API_KEY_FAILURE',
};

// Revoke API Key
export const REVOKE_API_KEY = {
  REQUEST: 'REVOKE_API_KEY_REQUEST',
  SUCCESS: 'REVOKE_API_KEY_SUCCESS',
  FAILURE: 'REVOKE_API_KEY_FAILURE',
};

// Reactivate API Key
export const REACTIVATE_API_KEY = {
  REQUEST: 'REACTIVATE_API_KEY_REQUEST',
  SUCCESS: 'REACTIVATE_API_KEY_SUCCESS',
  FAILURE: 'REACTIVATE_API_KEY_FAILURE',
};

// Delete API Key
export const DELETE_API_KEY = {
  REQUEST: 'DELETE_API_KEY_REQUEST',
  SUCCESS: 'DELETE_API_KEY_SUCCESS',
  FAILURE: 'DELETE_API_KEY_FAILURE',
};

// Clear new key (after user acknowledges)
export const CLEAR_NEW_API_KEY = 'CLEAR_NEW_API_KEY';

// ----------------------------------------------------------------------
// Action Creators

// Fetch API Keys List
export const fetchApiKeysRequest = (organizationId = null) => ({
  type: FETCH_API_KEYS.REQUEST,
  payload: { organizationId },
});

export const fetchApiKeysSuccess = (apiKeys) => ({
  type: FETCH_API_KEYS.SUCCESS,
  payload: apiKeys,
});

export const fetchApiKeysFailure = (error) => ({
  type: FETCH_API_KEYS.FAILURE,
  payload: error,
});

// Fetch API Key Detail
export const fetchApiKeyDetailRequest = (apiKeyId) => ({
  type: FETCH_API_KEY_DETAIL.REQUEST,
  payload: { apiKeyId },
});

export const fetchApiKeyDetailSuccess = (apiKey) => ({
  type: FETCH_API_KEY_DETAIL.SUCCESS,
  payload: apiKey,
});

export const fetchApiKeyDetailFailure = (error) => ({
  type: FETCH_API_KEY_DETAIL.FAILURE,
  payload: error,
});

// Create API Key
export const createApiKeyRequest = (data) => ({
  type: CREATE_API_KEY.REQUEST,
  payload: data,
});

export const createApiKeySuccess = (apiKey) => ({
  type: CREATE_API_KEY.SUCCESS,
  payload: apiKey,
});

export const createApiKeyFailure = (error) => ({
  type: CREATE_API_KEY.FAILURE,
  payload: error,
});

// Revoke API Key
export const revokeApiKeyRequest = (apiKeyId) => ({
  type: REVOKE_API_KEY.REQUEST,
  payload: { apiKeyId },
});

export const revokeApiKeySuccess = (apiKeyId) => ({
  type: REVOKE_API_KEY.SUCCESS,
  payload: { apiKeyId },
});

export const revokeApiKeyFailure = (error) => ({
  type: REVOKE_API_KEY.FAILURE,
  payload: error,
});

// Reactivate API Key
export const reactivateApiKeyRequest = (apiKeyId) => ({
  type: REACTIVATE_API_KEY.REQUEST,
  payload: { apiKeyId },
});

export const reactivateApiKeySuccess = (apiKeyId) => ({
  type: REACTIVATE_API_KEY.SUCCESS,
  payload: { apiKeyId },
});

export const reactivateApiKeyFailure = (error) => ({
  type: REACTIVATE_API_KEY.FAILURE,
  payload: error,
});

// Delete API Key
export const deleteApiKeyRequest = (apiKeyId) => ({
  type: DELETE_API_KEY.REQUEST,
  payload: { apiKeyId },
});

export const deleteApiKeySuccess = (apiKeyId) => ({
  type: DELETE_API_KEY.SUCCESS,
  payload: { apiKeyId },
});

export const deleteApiKeyFailure = (error) => ({
  type: DELETE_API_KEY.FAILURE,
  payload: error,
});

// Clear new key
export const clearNewApiKey = () => ({
  type: CLEAR_NEW_API_KEY,
});
